module.exports = __webpack_public_path__ + "img/text2.562a5bb1.png";